import { sessionNeverStarted } from './sessionPayment';

/** The statuses a session ends with energy delivered (the driver profile's
 *  COMPLETED_STATUSES). */
const FINISHED = new Set(['completed', 'stopped_by_user', 'stopped_by_system']);

/**
 * Whether a row of the driver profile's session list offers the EVI
 * Receipt PDF (Warren, 29 Oct 2026: support sends one session's receipt in
 * one click). Every finished session does, and so does a 'failed' one that
 * really ran: StopTransaction also writes 'failed' for a real session that
 * lost power, and that one can bill (lib/sessionPayment.ts). A start the
 * charger never ran (no real transaction id) has nothing to send, and a
 * live session has no receipt yet (the Api answers 409).
 */
export function sessionOffersReceipt(s: { status: string; transaction_id?: string | null }): boolean {
  if (FINISHED.has(s.status)) return true;
  return s.status === 'failed' && !sessionNeverStarted(s);
}
